import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { withAppContext } from "contexts/AppContext/AppContext";
import {
  buildAdviseesUri,
  buildLoginUri,
  buildDashboardUri,
  buildPoliciesUri,
} from "utils/routes";

const Base = ({ isLoggedIn, isUserLoading, isContributor }) => {
  const history = useHistory();

  useEffect(() => {
    if (!isUserLoading) {
      if (isLoggedIn) {
        if (isContributor) {
          history.push(buildPoliciesUri());
        } else {
          history.push(buildDashboardUri());
        }
      } else {
        history.push(buildLoginUri());
      }
    }
  }, [isLoggedIn, isUserLoading, history]);

  return <div />;
};

export default withAppContext(Base);
